export default __webpack_public_path__ + "static/media/linkedin.cbf3eac9.svg";